import React, { useContext, useRef, useState } from "react";

import { BoardContext } from "Boards/BoardContext";

import BoardButton from "../BoardButton";
import useBoardLocation from "../hooks/useBoardLocation";

import DeleteOrArchivePopover from "./DeleteOrArchivePopover";

export default function DeleteOrArchive() {
  const buttonRef = useRef();
  const [{ boardID, isArchived, groupURL }] = useContext(BoardContext);
  const { isReportBoard } = useBoardLocation();

  const [showTooltip, setShowTooltip] = useState(false);
  const [showPopover, setShowPopover] = useState(false);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);

  const handleClick = () => {
    setShowPopover((show) => !show);
  };

  const iconStyle = isArchived ? "fas" : "fad";
  const icon = "fa-archive";

  const getActiveElement = () => {
    if (showTooltip && !showPopover) return "tooltip";
    if (showDeleteConfirmation) return "delete";
    if (showPopover) return "popover";
    return null;
  };
  const activeElement = getActiveElement();

  // on launch we are only showing this on the reports page
  if (!isReportBoard) return null;

  return (
    <>
      <BoardButton
        ref={buttonRef}
        data-cy="saveDefaultFilter"
        onClick={handleClick}
        className={` ${iconStyle} ${icon} `}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
      />

      <DeleteOrArchivePopover
        setShowPopover={setShowPopover}
        buttonRef={buttonRef}
        activeElement={activeElement}
        setShowDeleteConfirmation={setShowDeleteConfirmation}
        isArchived={isArchived}
        boardID={boardID}
        groupURL={groupURL}
      />
    </>
  );
}
